export const GlobalNavigationItem = {
  /** トップ */
  TOP: 'top',
  /** 速報 */
  FLASH: 'flash',
  /** ライブ */
  LIVE: 'live',
  /** エキスパート */
  EXPERT: 'expert',
  /** オリジナル */
  ORIGINAL: 'original',
  /** みんなの意見 */
  POLLS: 'polls',
  /** ランキング */
  RANKING: 'ranking',
  /** 有料 */
  PAID_NEWS: 'paidNews'
} as const;

export type GlobalNavigationItem = (typeof GlobalNavigationItem)[keyof typeof GlobalNavigationItem];

/**
 * GlobalNavigationItem.RANKING
 * のうちのランキングタイプ
 */
export const RankingPageType = {
  // アクセスランキング
  ACCESS: 'access',
  // ヤフコメランキング
  COMMENT: 'comment'
} as const;

export type RankingPageType = (typeof RankingPageType)[keyof typeof RankingPageType];

/**
 * GlobalNavigationItem.EXPERT
 * のうちのページタイプ
 */
export const ExpertPageType = {
  // 新着記事
  NEW: 'new',
  // オーサー一覧
  AUTHOR: 'author',
  // クリエイター一覧
  CREATOR: 'creator',
  // コメンテーター一覧
  COMMENTATOR: 'commentator'
} as const;

export type ExpertPageType = (typeof ExpertPageType)[keyof typeof ExpertPageType];
